import React, { FunctionComponent, ReactElement } from 'react'
import { Skeleton, Theme, useIsTheme } from '@afterpaytouch/core'
import styles from './style.module.css'

export const ShippingOptionLoader: FunctionComponent = () => {
  const isAPTheme = useIsTheme(Theme.AP)

  const renderMultipleLoader = (amount: number): ReactElement[] => {
    return Array(amount)
      .fill(true)
      .map((_, i) => (
        <div className={styles.skeletonSkinny} key={i}>
          <Skeleton testNameSpace={`shipping-option-loader-${i}`} />
        </div>
      ))
  }
  return isAPTheme ? (
    <div className={styles.skeleton}>
      <Skeleton testNameSpace='shipping-option-loader' />
    </div>
  ) : (
    renderMultipleLoader(3)
  )
}
